const STORAGE_PREFIX = 'arkorbit_portal_doc_analyze_v1__';

export interface DocumentAnalyzeRecord {
  fingerprint: string;
  analyzedAt: number;
  extractRevision: number;
}

interface AnalyzeStore {
  version: 1;
  byFingerprint: Record<string, DocumentAnalyzeRecord>;
}

function storageKey(customerId: string): string {
  return `${STORAGE_PREFIX}${customerId}`;
}

function readStore(customerId: string): AnalyzeStore {
  try {
    const raw = sessionStorage.getItem(storageKey(customerId));
    if (!raw) return { version: 1, byFingerprint: {} };
    const parsed = JSON.parse(raw) as Partial<AnalyzeStore>;
    if (parsed.version !== 1 || !parsed.byFingerprint || typeof parsed.byFingerprint !== 'object') {
      return { version: 1, byFingerprint: {} };
    }
    return { version: 1, byFingerprint: parsed.byFingerprint };
  } catch {
    return { version: 1, byFingerprint: {} };
  }
}

function writeStore(customerId: string, store: AnalyzeStore): void {
  try {
    sessionStorage.setItem(storageKey(customerId), JSON.stringify(store));
  } catch {
    /* Quota / privater Modus */
  }
}

/** Stabile Kennung: Dokument-Identität + Extract-Revision + Kontextlänge. */
export function buildDocumentExtractFingerprint(args: {
  documentId: string;
  extractRevision: number;
  contextCharCount: number;
}): string | null {
  const docId = args.documentId.trim();
  if (!docId) return null;
  return `${docId}::r${args.extractRevision}::c${args.contextCharCount}`;
}

export function isDocumentAnalyzeDone(customerId: string, fingerprint: string | null | undefined): boolean {
  if (!customerId.trim() || !fingerprint?.trim()) return false;
  const store = readStore(customerId);
  return Boolean(store.byFingerprint[fingerprint]);
}

export function getDocumentAnalyzeRecord(
  customerId: string,
  fingerprint: string | null | undefined,
): DocumentAnalyzeRecord | null {
  if (!customerId.trim() || !fingerprint?.trim()) return null;
  return readStore(customerId).byFingerprint[fingerprint] ?? null;
}

export function markDocumentAnalyzeDone(
  customerId: string,
  fingerprint: string,
  extractRevision: number,
): void {
  if (!customerId.trim() || !fingerprint.trim()) return;
  const store = readStore(customerId);
  store.byFingerprint[fingerprint] = {
    fingerprint,
    analyzedAt: Date.now(),
    extractRevision,
  };
  writeStore(customerId, store);
}

export function clearDocumentAnalyzeGuard(customerId: string): void {
  try {
    sessionStorage.removeItem(storageKey(customerId));
  } catch {
    /* noop */
  }
}
